import {
   FaDoorOpen,
   FaDoorClosed,
   FaExclamationTriangle,
   FaBell,
   FaSatelliteDish,
   FaPowerOff,
   FaRedo,
   FaUndo,
   FaSignInAlt,
   FaSignOutAlt,
   FaPlay,
   FaCog,
   FaEdit,
   FaHandPointer,
   FaIdCard,
   FaKey,
   FaFingerprint,
   FaGamepad,
   FaQuestionCircle,
   FaCode,
   FaLock,
   FaLockOpen,
   FaUserSlash,
   FaMapMarkedAlt,
   FaBuilding,
   FaUsersSlash,
   FaVideo,
   FaArrowDown,
   FaArrowUp,
   FaStream,
   FaPauseCircle,
   FaUserClock,
   FaCheckCircle,
   FaTicketAlt,
   FaParking,
   FaHourglassHalf,
   FaQrcode,
   FaToggleOn,
   FaToggleOff,
   FaRobot,
   FaBolt,
   FaPlug,
   FaTimesCircle,
   FaBroadcastTower,
   FaCamera,
   FaExchangeAlt,
   FaThermometerHalf,
   FaUserShield,
   FaCar,
   FaCarSide,
   FaPrint,
} from "react-icons/fa";

import {
   RiSignalTowerFill,
} from "react-icons/ri";

import {
   LuTrash,
} from "react-icons/lu";

export const EVENT_TYPES = {
   System: 'Sistema',
   Access: 'Acesso',
   Configuration: 'Configuracao',
   Alarm: 'Alarme',
}

export function getEventTypeTranslationKey(eventType) {
   switch (eventType) {
      case EVENT_TYPES.System:
         return "events.system";
      case EVENT_TYPES.Access:
         return "events.access";
      case EVENT_TYPES.Configuration:
         return "events.configuration";
      case EVENT_TYPES.Alarm:
         return "events.alarm";
      default:
         return eventType;
   }
}

export const EVENTS = [
   // ALARME
   {
      id: "0-0",
      type: "Alarme",
      original: "Porta aberta",
      formatted: "Porta aberta",
      translationKey: "events.doorOpen",
      icon: FaDoorOpen,
   },
   {
      id: "0-2",
      type: "Alarme",
      original: "Porta violada",
      formatted: "Porta violada",
      translationKey: "events.doorViolated",
      icon: FaExclamationTriangle,
   },
   {
      id: "0-6",
      type: "Alarme",
      original: "Credencial panico",
      formatted: "Credencial de pânico",
      translationKey: "events.panicCredential",
      icon: FaBell,
   },

   // SISTEMA
   {
      id: "1-13",
      type: "Sistema",
      original: "Comando remoto",
      formatted: "Comando remoto",
      translationKey: "events.remoteCommand",
      icon: RiSignalTowerFill,
   },
   {
      id: "1-17",
      type: "Sistema",
      original: "Boot finalizado",
      formatted: "Boot finalizado",
      translationKey: "events.bootFinished",
      icon: FaPlay,
   },
   {
      id: "1-18",
      type: "Sistema",
      original: "Reboot solicitado",
      formatted: "Reboot solicitado",
      translationKey: "events.rebootRequested",
      icon: FaRedo,
   },
   {
      id: "1-18-1",
      type: "Sistema",
      original: "Reboot",
      formatted: "Reboot",
      translationKey: "events.reboot",
      icon: FaRedo,
   },
   {
      id: "1-19",
      type: "Sistema",
      original: "Reset de fabrica",
      formatted: "Reset de fábrica",
      translationKey: "events.factoryReset",
      icon: FaUndo,
   },
   {
      id: "1-20",
      type: "Sistema",
      original: "Desligamento solicitado",
      formatted: "Desligamento solicitado",
      translationKey: "events.shutdownRequested",
      icon: FaPowerOff,
   },
   {
      id: "1-21",
      type: "Sistema",
      original: "Login",
      formatted: "Login",
      translationKey: "events.login",
      icon: FaSignInAlt,
   },
   {
      id: "1-22",
      type: "Sistema",
      original: "Logout",
      formatted: "Logout",
      translationKey: "events.logout",
      icon: FaSignOutAlt,
   },
   {
      id: "1-24",
      type: "Sistema",
      original: "Sistema executando",
      formatted: "Sistema executando",
      translationKey: "events.systemRunning",
      icon: FaCog,
   },

   // CONFIG
   {
      id: "2-23",
      type: "Configuracao",
      original: "Edicao de dados",
      formatted: "Edição de dados",
      translationKey: "events.dataEditing",
      icon: FaEdit,
   },

   // ACESSO
   {
      id: "3-0",
      type: "Acesso",
      original: "Porta aberta",
      formatted: "Porta aberta",
      translationKey: "events.doorOpen",
      icon: FaDoorOpen,
   },
   {
      id: "3-1",
      type: "Acesso",
      original: "Porta fechada",
      formatted: "Porta fechada",
      translationKey: "events.doorClosed",
      icon: FaDoorClosed,
   },
   {
      id: "3-3",
      type: "Acesso",
      original: "Botao pressionado",
      formatted: "Botão pressionado",
      translationKey: "events.buttonPressed",
      icon: FaHandPointer,
   },
   {
      id: "3-4",
      type: "Acesso",
      original: "Credencial tag",
      formatted: "Credencial por tag",
      translationKey: "events.tagCredential",
      icon: FaIdCard,
   },
   {
      id: "3-5",
      type: "Acesso",
      original: "Credencial senha",
      formatted: "Credencial por senha",
      translationKey: "events.passwordCredential",
      icon: FaKey,
   },
   {
      id: "3-6",
      type: "Acesso",
      original: "Credencial panico",
      formatted: "Credencial de pânico",
      translationKey: "events.panicCredential",
      icon: FaBell,
   },
   {
      id: "3-7",
      type: "Acesso",
      original: "Credencial biometria",
      formatted: "Credencial por biometria",
      translationKey: "events.biometricCredential",
      icon: FaFingerprint,
   },
   {
      id: "3-8",
      type: "Acesso",
      original: "Credencial controle",
      formatted: "Credencial por controle",
      translationKey: "events.controlCredential",
      icon: FaGamepad,
   },
   {
      id: "3-9",
      type: "Acesso",
      original: "Credencial desconhecida",
      formatted: "Credencial desconhecida",
      translationKey: "events.unknownCredential",
      icon: FaQuestionCircle,
   },
   {
      id: "3-13",
      type: "Acesso",
      original: "Comando remoto",
      formatted: "Comando remoto",
      translationKey: "events.remoteCommand",
      icon: RiSignalTowerFill,
   },
   {
      id: "3-25",
      type: "Acesso",
      original: "Credencial de API",
      formatted: "Credencial de API",
      translationKey: "events.apiCredential",
      icon: FaCode,
   },
   {
      id: "3-28",
      type: "Acesso",
      original: "Solicitado travar porta",
      formatted: "Solicitado travar porta",
      translationKey: "events.lockDoorRequested",
      icon: FaLock,
   },
   {
      id: "3-29",
      type: "Acesso",
      original: "Solicitado destravar porta",
      formatted: "Solicitado destravar porta",
      translationKey: "events.unlockDoorRequested",
      icon: FaLockOpen,
   },
   {
      id: "3-30",
      type: "Acesso",
      original: "Usuario desabilitado",
      formatted: "Usuário desabilitado",
      translationKey: "events.userDisabled",
      icon: FaUserSlash,
   },
   {
      id: "3-31",
      type: "Acesso",
      original: "Solicitado abrir porta",
      formatted: "Solicitado abrir porta",
      translationKey: "events.openDoorRequested",
      icon: FaDoorOpen,
   },
   {
      id: "3-32",
      type: "Acesso",
      original: "Credencial QRCode",
      formatted: "Credencial por QR Code",
      translationKey: "events.qrCodeCredential",
      icon: FaQrcode,
   },
   {
      id: "3-33",
      type: "Acesso",
      original: "Rele acionado",
      formatted: "Relé acionado",
      translationKey: "events.relayActivated",
      icon: FaToggleOn,
   },
   {
      id: "3-34",
      type: "Acesso",
      original: "Rele liberado",
      formatted: "Relé liberado",
      translationKey: "events.relayReleased",
      icon: FaToggleOff,
   },
   {
      id: "3-36",
      type: "Acesso",
      original: "Credencial CtrlId",
      formatted: "Credencial CtrlId",
      translationKey: "events.ctrlIdCredential",
      icon: FaIdCard,
   },

   // AUTOMAÇÃO
   {
      id: "5-13",
      type: "Automacao",
      original: "Comando remoto",
      formatted: "Comando remoto",
      translationKey: "events.remoteCommand",
      icon: RiSignalTowerFill,
   },
   {
      id: "5-26",
      type: "Automacao",
      original: "Acao de automacao",
      formatted: "Ação de automação",
      translationKey: "events.automationAction",
      icon: FaRobot,
   },
   {
      id: "5-27",
      type: "Automacao",
      original: "Evento de automacao",
      formatted: "Evento de automação",
      translationKey: "events.automationEvent",
      icon: FaBolt,
   },
   {
      id: "5-28",
      type: "Automacao",
      original: "Solicitado travar porta",
      formatted: "Solicitado travar porta",
      translationKey: "events.lockDoorRequested",
      icon: FaLock,
   },
   {
      id: "5-29",
      type: "Automacao",
      original: "Solicitado destravar porta",
      formatted: "Solicitado destravar porta",
      translationKey: "events.unlockDoorRequested",
      icon: FaLockOpen,
   },
   {
      id: "5-31",
      type: "Automacao",
      original: "Solicitado abrir porta",
      formatted: "Solicitado abrir porta",
      translationKey: "events.openDoorRequested",
      icon: FaDoorOpen,
   },
   {
      id: "5-35",
      type: "Automacao",
      original: "Estado de entrada PGM",
      formatted: "Estado da entrada PGM",
      translationKey: "events.pgmInputState",
      icon: FaPlug,
   },

   // ACESSO
   {
      id: "3-37",
      type: "Acesso",
      original: "Credencial incompativel",
      formatted: "Credencial incompatível",
      translationKey: "events.incompatibleCredential",
      icon: FaTimesCircle,
   },
   {
      id: "3-38",
      type: "Acesso",
      original: "Credencial Remota",
      formatted: "Credencial remota",
      translationKey: "events.remoteCredential",
      icon: FaSatelliteDish,
   },

   // ALARME
   {
      id: "0-27",
      type: "Alarme",
      original: "Evento de automacao",
      formatted: "Evento de automação",
      translationKey: "events.automationEvent",
      icon: FaBolt,
   },
   {
      id: "0-39",
      type: "Alarme",
      original: "Sensor PGM",
      formatted: "Sensor PGM",
      translationKey: "events.pgmSensor",
      icon: FaBroadcastTower,
   },

   // ACESSO
   {
      id: "3-27",
      type: "Acesso",
      original: "Evento de automacao",
      formatted: "Evento de automação",
      translationKey: "events.automationEvent",
      icon: FaBolt,
   },
   {
      id: "3-40",
      type: "Acesso",
      original: "Credencial Hikvision",
      formatted: "Credencial Hikvision",
      translationKey: "events.hikvisionCredential",
      icon: FaCamera,
   },
   {
      id: "3-42",
      type: "Acesso",
      original: "Catraca entrou",
      formatted: "Catraca entrou",
      translationKey: "events.turnstileEntered",
      icon: FaSignInAlt,
   },
   {
      id: "3-43",
      type: "Acesso",
      original: "Catraca saiu",
      formatted: "Catraca saiu",
      translationKey: "events.turnstileExited",
      icon: FaSignOutAlt,
   },
   {
      id: "3-44",
      type: "Acesso",
      original: "Catraca urna",
      formatted: "Catraca urna",
      translationKey: "events.turnstileUrn",
      icon: FaExchangeAlt,
   },
   {
      id: "3-47",
      type: "Acesso",
      original: "Temperatura anomala",
      formatted: "Temperatura anômala",
      translationKey: "events.anomalousTemperature",
      icon: FaThermometerHalf,
   },
   {
      id: "3-48",
      type: "Acesso",
      original: "Sem mascara",
      formatted: "Sem máscara",
      translationKey: "events.withoutMask",
      icon: FaUserShield,
   },
   {
      id: "3-49",
      type: "Acesso",
      original: "Intertravamento alterado remotamente",
      formatted: "Intertravamento alterado remotamente",
      translationKey: "events.interlockChangedRemotely",
      icon: FaExchangeAlt,
   },
   {
      id: "3-50",
      type: "Acesso",
      original: "Credencial indah",
      formatted: "Credencial Indah",
      translationKey: "events.indahCredential",
      icon: FaIdCard,
   },
   {
      id: "3-51",
      type: "Acesso",
      original: "Veiculo entrou",
      formatted: "Veículo entrou",
      translationKey: "events.vehicleEntered",
      icon: FaCarSide,
   },
   {
      id: "3-52",
      type: "Acesso",
      original: "Veiculo saiu",
      formatted: "Veículo saiu",
      translationKey: "events.vehicleExited",
      icon: FaCarSide,
   },
   {
      id: "3-53",
      type: "Acesso",
      original: "Impressão de QRCode",
      formatted: "Impressão de QR Code",
      translationKey: "events.qrCodePrinting",
      icon: FaPrint,
   },
   {
      id: "3-54",
      type: "Acesso",
      original: "Credencial Lpr",
      formatted: "Credencial LPR",
      translationKey: "events.lprCredential",
      icon: FaCar,
   },
   {
      id: "3-55",
      type: "Acesso",
      original: "Credencial Alphadigi",
      formatted: "Credencial Alphadigi",
      translationKey: "events.alphadigiCredential",
      icon: FaFingerprint,
   },
   {
      id: "3-57",
      type: "Acesso",
      original: "Botao remoto",
      formatted: "Botão remoto",
      translationKey: "events.remoteButton",
      icon: RiSignalTowerFill,
   },

   // CONFIG
   {
      id: "2-58",
      type: "Configuracao",
      original: "Limpa credenciais",
      formatted: "Limpar credenciais",
      translationKey: "events.clearCredentials",
      icon: LuTrash,
   },
   // ACESSO
   {
      id: "3-59",
      type: "Acesso",
      original: "Credencial SemParar",
      formatted: "Credencial SemParar",
      translationKey: "events.semPararCredential",
      icon: FaCar,
   },
   {
      id: "3-60",
      type: "Acesso",
      original: "Liga Rele auxiliar IP",
      formatted: "Ligar relé auxiliar IP",
      translationKey: "events.turnOnIpAuxiliaryRelay",
      icon: FaToggleOn,
   },
   {
      id: "3-61",
      type: "Acesso",
      original: "Desliga rele auxiliar IP",
      formatted: "Desligar relé auxiliar IP",
      translationKey: "events.turnOffIpAuxiliaryRelay",
      icon: FaToggleOff,
   },
   {
      id: "3-62",
      type: "Acesso",
      original: "Pulsa rele auxiliar IP",
      formatted: "Pulsar relé auxiliar IP",
      translationKey: "events.pulseIpAuxiliaryRelay",
      icon: FaBolt,
   },
   {
      id: "3-63",
      type: "Acesso",
      original: "Limite de ambiente",
      formatted: "Limite de ambiente",
      translationKey: "events.environmentLimit",
      icon: FaMapMarkedAlt,
   },
   {
      id: "3-64",
      type: "Acesso",
      original: "Limite de unidade",
      formatted: "Limite de unidade",
      translationKey: "events.unitLimit",
      icon: FaBuilding,
   },
   {
      id: "3-65",
      type: "Acesso",
      original: "Grupo incorreto em area",
      formatted: "Grupo incorreto em área",
      translationKey: "events.incorrectGroupInArea",
      icon: FaUsersSlash,
   },
   {
      id: "3-66",
      type: "Acesso",
      original: "Credencial Avicam",
      formatted: "Credencial Avicam",
      translationKey: "events.avicamCredential",
      icon: FaVideo,
   },
   {
      id: "3-67",
      type: "Acesso",
      original: "Ativa braco que cai",
      formatted: "Ativar braço que cai",
      translationKey: "events.activateDropArm",
      icon: FaArrowDown,
   },
   {
      id: "3-68",
      type: "Acesso",
      original: "Desativa braco que cai",
      formatted: "Desativar braço que cai",
      translationKey: "events.deactivateDropArm",
      icon: FaArrowUp,
   },
   {
      id: "3-69",
      type: "Acesso",
      original: "Ativa libera fluxo",
      formatted: "Ativar libera fluxo",
      translationKey: "events.activateFreeFlow",
      icon: FaStream,
   },
   {
      id: "3-70",
      type: "Acesso",
      original: "Desativa libera fluxo",
      formatted: "Desativar libera fluxo",
      translationKey: "events.deactivateFreeFlow",
      icon: FaPauseCircle,
   },
   {
      id: "3-71",
      type: "Acesso",
      original: "Autorizador ausente",
      formatted: "Autorizador ausente",
      translationKey: "events.authorizerAbsent",
      icon: FaUserClock,
   },
   {
      id: "3-72",
      type: "Acesso",
      original: "Crendencial Positivo",
      formatted: "Credencial positiva",
      translationKey: "events.positiveCredential",
      icon: FaCheckCircle,
   },
   {
      id: "3-73",
      type: "Acesso",
      original: "Solicita ticket",
      formatted: "Solicitar ticket",
      translationKey: "events.requestTicket",
      icon: FaTicketAlt,
   },
   {
      id: "3-74",
      type: "Acesso",
      original: "Estacionamento entrou",
      formatted: "Entrada no estacionamento",
      translationKey: "events.parkingEntry",
      icon: FaParking,
   },
   {
      id: "3-75",
      type: "Acesso",
      original: "Estacionamento saiu",
      formatted: "Saída do estacionamento",
      translationKey: "events.parkingExit",
      icon: FaParking,
   },
   {
      id: "3-76",
      type: "Acesso",
      original: "Timeout de acesso estacionamento",
      formatted: "Timeout de acesso ao estacionamento",
      translationKey: "events.parkingAccessTimeout",
      icon: FaHourglassHalf,
   },
   {
      id: "3-78",
      type: "Acesso",
      original: "Solicita saida estacionamento",
      formatted: "Solicitar saída do estacionamento",
      translationKey: "events.requestParkingExit",
      icon: FaSignOutAlt,
   },

   // SISTEMA
   {
      id: "1-41",
      type: "Sistema",
      original: "Limpar log",
      formatted: "Limpar log",
      translationKey: "events.clearLog",
      icon: LuTrash,
   },
   {
      id: "1-77",
      type: "Sistema",
      original: "Reset de uso de unidades",
      formatted: "Reset de uso de unidades",
      translationKey: "events.unitUsageReset",
      icon: FaUndo,
   },
];

// export const EVENTS = [
//    // ALARME
//    {
//       id: "0-0",
//       type: "Alarme",
//       original: "Porta aberta",
//       formatted: "Porta aberta",
//       icon: FaDoorOpen,
//    },
//    {
//       id: "0-2",
//       type: "Alarme",
//       original: "Porta violada",
//       formatted: "Porta violada",
//       icon: FaExclamationTriangle,
//    },
//    {
//       id: "0-6",
//       type: "Alarme",
//       original: "Credencial panico",
//       formatted: "Credencial de pânico",
//       icon: FaBell,
//    },

//    // SISTEMA
//    {
//       id: "1-13",
//       type: "Sistema",
//       original: "Comando remoto",
//       formatted: "Comando remoto",
//       icon: RiSignalTowerFill,
//    },
//    {
//       id: "1-17",
//       type: "Sistema",
//       original: "Boot finalizado",
//       formatted: "Boot finalizado",
//       icon: FaPlay,
//    },
//    {
//       id: "1-18",
//       type: "Sistema",
//       original: "Reboot solicitado",
//       formatted: "Reboot solicitado",
//       icon: FaRedo,
//    },
//    {
//       id: "1-18-1",
//       type: "Sistema",
//       original: "Reboot",
//       formatted: "Reboot",
//       icon: FaRedo,
//    },
//    {
//       id: "1-19",
//       type: "Sistema",
//       original: "Reset de fabrica",
//       formatted: "Reset de fábrica",
//       icon: FaUndo,
//    },
//    {
//       id: "1-20",
//       type: "Sistema",
//       original: "Desligamento solicitado",
//       formatted: "Desligamento solicitado",
//       icon: FaPowerOff,
//    },
//    {
//       id: "1-21",
//       type: "Sistema",
//       original: "Login",
//       formatted: "Login",
//       icon: FaSignInAlt,
//    },
//    {
//       id: "1-22",
//       type: "Sistema",
//       original: "Logout",
//       formatted: "Logout",
//       icon: FaSignOutAlt,
//    },
//    {
//       id: "1-24",
//       type: "Sistema",
//       original: "Sistema executando",
//       formatted: "Sistema executando",
//       icon: FaCog,
//    },

//    // CONFIG
//    {
//       id: "2-23",
//       type: "Configuracao",
//       original: "Edicao de dados",
//       formatted: "Edição de dados",
//       icon: FaEdit,
//    },

//    // ACESSO
//    {
//       id: "3-0",
//       type: "Acesso",
//       original: "Porta aberta",
//       formatted: "Porta aberta",
//       icon: FaDoorOpen,
//    },
//    {
//       id: "3-1",
//       type: "Acesso",
//       original: "Porta fechada",
//       formatted: "Porta fechada",
//       icon: FaDoorClosed,
//    },
//    {
//       id: "3-3",
//       type: "Acesso",
//       original: "Botao pressionado",
//       formatted: "Botão pressionado",
//       icon: FaHandPointer,
//    },
//    {
//       id: "3-4",
//       type: "Acesso",
//       original: "Credencial tag",
//       formatted: "Credencial por tag",
//       icon: FaIdCard,
//    },
//    {
//       id: "3-5",
//       type: "Acesso",
//       original: "Credencial senha",
//       formatted: "Credencial por senha",
//       icon: FaKey,
//    },
//    {
//       id: "3-6",
//       type: "Acesso",
//       original: "Credencial panico",
//       formatted: "Credencial de pânico",
//       icon: FaBell,
//    },
//    {
//       id: "3-7",
//       type: "Acesso",
//       original: "Credencial biometria",
//       formatted: "Credencial por biometria",
//       icon: FaFingerprint,
//    },
//    {
//       id: "3-8",
//       type: "Acesso",
//       original: "Credencial controle",
//       formatted: "Credencial por controle",
//       icon: FaGamepad,
//    },
//    {
//       id: "3-9",
//       type: "Acesso",
//       original: "Credencial desconhecida",
//       formatted: "Credencial desconhecida",
//       icon: FaQuestionCircle,
//    },
//    {
//       id: "3-13",
//       type: "Acesso",
//       original: "Comando remoto",
//       formatted: "Comando remoto",
//       icon: RiSignalTowerFill,
//    },
//    {
//       id: "3-25",
//       type: "Acesso",
//       original: "Credencial de API",
//       formatted: "Credencial de API",
//       icon: FaCode,
//    },
//    {
//       id: "3-28",
//       type: "Acesso",
//       original: "Solicitado travar porta",
//       formatted: "Solicitado travar porta",
//       icon: FaLock,
//    },
//    {
//       id: "3-29",
//       type: "Acesso",
//       original: "Solicitado destravar porta",
//       formatted: "Solicitado destravar porta",
//       icon: FaLockOpen,
//    },
//    {
//       id: "3-30",
//       type: "Acesso",
//       original: "Usuario desabilitado",
//       formatted: "Usuário desabilitado",
//       icon: FaUserSlash,
//    },
//    {
//       id: "3-31",
//       type: "Acesso",
//       original: "Solicitado abrir porta",
//       formatted: "Solicitado abrir porta",
//       icon: FaDoorOpen,
//    },
//    {
//       id: "3-32",
//       type: "Acesso",
//       original: "Credencial QRCode",
//       formatted: "Credencial por QR Code",
//       icon: FaQrcode,
//    },
//    {
//       id: "3-33",
//       type: "Acesso",
//       original: "Rele acionado",
//       formatted: "Relé acionado",
//       icon: FaToggleOn,
//    },
//    {
//       id: "3-34",
//       type: "Acesso",
//       original: "Rele liberado",
//       formatted: "Relé liberado",
//       icon: FaToggleOff,
//    },
//    {
//       id: "3-36",
//       type: "Acesso",
//       original: "Credencial CtrlId",
//       formatted: "Credencial CtrlId",
//       icon: FaIdCard,
//    },

//    // AUTOMAÇÃO
//    {
//       id: "5-13",
//       type: "Automacao",
//       original: "Comando remoto",
//       formatted: "Comando remoto",
//       icon: RiSignalTowerFill,
//    },
//    {
//       id: "5-26",
//       type: "Automacao",
//       original: "Acao de automacao",
//       formatted: "Ação de automação",
//       icon: FaRobot,
//    },
//    {
//       id: "5-27",
//       type: "Automacao",
//       original: "Evento de automacao",
//       formatted: "Evento de automação",
//       icon: FaBolt,
//    },
//    {
//       id: "5-28",
//       type: "Automacao",
//       original: "Solicitado travar porta",
//       formatted: "Solicitado travar porta",
//       icon: FaLock,
//    },
//    {
//       id: "5-29",
//       type: "Automacao",
//       original: "Solicitado destravar porta",
//       formatted: "Solicitado destravar porta",
//       icon: FaLockOpen,
//    },
//    {
//       id: "5-31",
//       type: "Automacao",
//       original: "Solicitado abrir porta",
//       formatted: "Solicitado abrir porta",
//       icon: FaDoorOpen,
//    },
//    {
//       id: "5-35",
//       type: "Automacao",
//       original: "Estado de entrada PGM",
//       formatted: "Estado da entrada PGM",
//       icon: FaPlug,
//    },

//    // ACESSO
//    {
//       id: "3-37",
//       type: "Acesso",
//       original: "Credencial incompativel",
//       formatted: "Credencial incompatível",
//       icon: FaTimesCircle,
//    },
//    {
//       id: "3-38",
//       type: "Acesso",
//       original: "Credencial Remota",
//       formatted: "Credencial remota",
//       icon: FaSatelliteDish,
//    },

//    // ALARME
//    {
//       id: "0-27",
//       type: "Alarme",
//       original: "Evento de automacao",
//       formatted: "Evento de automação",
//       icon: FaBolt,
//    },
//    {
//       id: "0-39",
//       type: "Alarme",
//       original: "Sensor PGM",
//       formatted: "Sensor PGM",
//       icon: FaBroadcastTower,
//    },

//    // ACESSO
//    {
//       id: "3-27",
//       type: "Acesso",
//       original: "Evento de automacao",
//       formatted: "Evento de automação",
//       icon: FaBolt,
//    },
//    {
//       id: "3-40",
//       type: "Acesso",
//       original: "Credencial Hikvision",
//       formatted: "Credencial Hikvision",
//       icon: FaCamera,
//    },
//    {
//       id: "3-42",
//       type: "Acesso",
//       original: "Catraca entrou",
//       formatted: "Catraca entrou",
//       icon: FaSignInAlt,
//    },
//    {
//       id: "3-43",
//       type: "Acesso",
//       original: "Catraca saiu",
//       formatted: "Catraca saiu",
//       icon: FaSignOutAlt,
//    },
//    {
//       id: "3-44",
//       type: "Acesso",
//       original: "Catraca urna",
//       formatted: "Catraca urna",
//       icon: FaExchangeAlt,
//    },
//    {
//       id: "3-47",
//       type: "Acesso",
//       original: "Temperatura anomala",
//       formatted: "Temperatura anômala",
//       icon: FaThermometerHalf,
//    },
//    {
//       id: "3-48",
//       type: "Acesso",
//       original: "Sem mascara",
//       formatted: "Sem máscara",
//       icon: FaUserShield,
//    },
//    {
//       id: "3-49",
//       type: "Acesso",
//       original: "Intertravamento alterado remotamente",
//       formatted: "Intertravamento alterado remotamente",
//       icon: FaExchangeAlt,
//    },
//    {
//       id: "3-50",
//       type: "Acesso",
//       original: "Credencial indah",
//       formatted: "Credencial Indah",
//       icon: FaIdCard,
//    },
//    {
//       id: "3-51",
//       type: "Acesso",
//       original: "Veiculo entrou",
//       formatted: "Veículo entrou",
//       icon: FaCarSide,
//    },
//    {
//       id: "3-52",
//       type: "Acesso",
//       original: "Veiculo saiu",
//       formatted: "Veículo saiu",
//       icon: FaCarSide,
//    },
//    {
//       id: "3-53",
//       type: "Acesso",
//       original: "Impressão de QRCode",
//       formatted: "Impressão de QR Code",
//       icon: FaPrint,
//    },
//    {
//       id: "3-54",
//       type: "Acesso",
//       original: "Credencial Lpr",
//       formatted: "Credencial LPR",
//       icon: FaCar,
//    },
//    {
//       id: "3-55",
//       type: "Acesso",
//       original: "Credencial Alphadigi",
//       formatted: "Credencial Alphadigi",
//       icon: FaFingerprint,
//    },
//    {
//       id: "3-57",
//       type: "Acesso",
//       original: "Botao remoto",
//       formatted: "Botão remoto",
//       icon: RiSignalTowerFill,
//    },

//    // CONFIG
//    {
//       id: "2-58",
//       type: "Configuracao",
//       original: "Limpa credenciais",
//       formatted: "Limpar credenciais",
//       icon: LuTrash,
//    },
//    // ACESSO
//    {
//       id: "3-59",
//       type: "Acesso",
//       original: "Credencial SemParar",
//       formatted: "Credencial SemParar",
//       icon: FaCar,
//    },
//    {
//       id: "3-60",
//       type: "Acesso",
//       original: "Liga Rele auxiliar IP",
//       formatted: "Ligar relé auxiliar IP",
//       icon: FaToggleOn,
//    },
//    {
//       id: "3-61",
//       type: "Acesso",
//       original: "Desliga rele auxiliar IP",
//       formatted: "Desligar relé auxiliar IP",
//       icon: FaToggleOff,
//    },
//    {
//       id: "3-62",
//       type: "Acesso",
//       original: "Pulsa rele auxiliar IP",
//       formatted: "Pulsar relé auxiliar IP",
//       icon: FaBolt,
//    },
//    {
//       id: "3-63",
//       type: "Acesso",
//       original: "Limite de ambiente",
//       formatted: "Limite de ambiente",
//       icon: FaMapMarkedAlt,
//    },
//    {
//       id: "3-64",
//       type: "Acesso",
//       original: "Limite de unidade",
//       formatted: "Limite de unidade",
//       icon: FaBuilding,
//    },
//    {
//       id: "3-65",
//       type: "Acesso",
//       original: "Grupo incorreto em area",
//       formatted: "Grupo incorreto em área",
//       icon: FaUsersSlash,
//    },
//    {
//       id: "3-66",
//       type: "Acesso",
//       original: "Credencial Avicam",
//       formatted: "Credencial Avicam",
//       icon: FaVideo,
//    },
//    {
//       id: "3-67",
//       type: "Acesso",
//       original: "Ativa braco que cai",
//       formatted: "Ativar braço que cai",
//       icon: FaArrowDown,
//    },
//    {
//       id: "3-68",
//       type: "Acesso",
//       original: "Desativa braco que cai",
//       formatted: "Desativar braço que cai",
//       icon: FaArrowUp,
//    },
//    {
//       id: "3-69",
//       type: "Acesso",
//       original: "Ativa libera fluxo",
//       formatted: "Ativar libera fluxo",
//       icon: FaStream,
//    },
//    {
//       id: "3-70",
//       type: "Acesso",
//       original: "Desativa libera fluxo",
//       formatted: "Desativar libera fluxo",
//       icon: FaPauseCircle,
//    },
//    {
//       id: "3-71",
//       type: "Acesso",
//       original: "Autorizador ausente",
//       formatted: "Autorizador ausente",
//       icon: FaUserClock,
//    },
//    {
//       id: "3-72",
//       type: "Acesso",
//       original: "Crendencial Positivo",
//       formatted: "Credencial positiva",
//       icon: FaCheckCircle,
//    },
//    {
//       id: "3-73",
//       type: "Acesso",
//       original: "Solicita ticket",
//       formatted: "Solicitar ticket",
//       icon: FaTicketAlt,
//    },
//    {
//       id: "3-74",
//       type: "Acesso",
//       original: "Estacionamento entrou",
//       formatted: "Entrada no estacionamento",
//       icon: FaParking,
//    },
//    {
//       id: "3-75",
//       type: "Acesso",
//       original: "Estacionamento saiu",
//       formatted: "Saída do estacionamento",
//       icon: FaParking,
//    },
//    {
//       id: "3-76",
//       type: "Acesso",
//       original: "Timeout de acesso estacionamento",
//       formatted: "Timeout de acesso ao estacionamento",
//       icon: FaHourglassHalf,
//    },
//    {
//       id: "3-78",
//       type: "Acesso",
//       original: "Solicita saida estacionamento",
//       formatted: "Solicitar saída do estacionamento",
//       icon: FaSignOutAlt,
//    },

//    // SISTEMA
//    {
//       id: "1-41",
//       type: "Sistema",
//       original: "Limpar log",
//       formatted: "Limpar log",
//       icon: LuTrash,
//    },
//    {
//       id: "1-77",
//       type: "Sistema",
//       original: "Reset de uso de unidades",
//       formatted: "Reset de uso de unidades",
//       icon: FaUndo,
//    },
// ];

export function getEventTypeName(eventName) {
   const event = Object.entries(EVENT_TYPES).find(([key, value]) => value === eventName);
   return getEventTypeTranslationKey(event?.[1] || eventName);
}

export function getEventData(eventName, eventId = null) {
   const event = EVENTS.find(e => e.original === eventName || e.id === eventId);
   if (!event) return null;
   return {
      name: event.translationKey,
      icon: event.icon,
   };
}